const swiperLogos = new Swiper('.swiper-logos__swiper', {
	loop: true,
	slidesPerView: 2,
	spaceBetween: 86,
	speed: 3500,
	autoplay: {
		delay: 0
	},
	breakpoints: {
		768: {
			slidesPerView: 3
		},
		1200: {
			slidesPerView: 4
		},
		1400: {
			slidesPerView: 5
		}
	}
});

const swiperHero = new Swiper('.hero-slider__swiper', {
	loop: true,
	slidesPerView: 1,
	spaceBetween: 24,
	autoplay: {
		delay: 4000
	},
	pagination: {
		el: '.hero-slider__swiper-pagination',
		clickable: true
	},
	navigation: {
		nextEl: '.hero-slider__swiper-button-next',
		prevEl: '.hero-slider__swiper-button-prev'
	}
});

const swiperTextTiles = new Swiper('.text-tiles__tiles', {
	loop: true,
	slidesPerView: 1.2,
	spaceBetween: 24,
	breakpoints: {
		768: {
			slidesPerView: 2.2,
			spaceBetween: 32
		},
		1200: {
			slidesPerView: 3
		}
	},
	pagination: {
		el: '.text-tiles__swiper-pagination',
		clickable: true
	}
});

const swiper = new Swiper('.text-gallery__thumb-swiper', {
	spaceBetween: 24,
	slidesPerView: 3,
	freeMode: true,
	watchSlidesProgress: true,
	breakpoints: {
		1200: {
			direction: 'vertical',
			spaceBetween: 12
		}
	}
});

const swiper2 = new Swiper('.text-gallery__main-swiper', {
	slidesPerView: 1,
	effect: 'fade',
	thumbs: {
		swiper: swiper
	}
});

const swiperBestsellers = new Swiper('.bestsellers__tiles', {
	loop: true,
	slidesPerView: 1,
	spaceBetween: 32,
	breakpoints: {
		768: {
			slidesPerView: 2
		},
		992: {
			slidesPerView: 3
		},
		1200: {
			slidesPerView: 4
		}
	},
	pagination: {
		el: '.bestsellers__swiper-pagination',
		clickable: true
	}
});

const swiperOpinions = new Swiper('.testimonials__swiper', {
	loop: true,
	slidesPerView: 1,
	spaceBetween: 32,
	grabCursor: true,
	pagination: {
		el: '.testimonials__swiper-pagination',
		clickable: true
	},
	breakpoints: {
		768: {
			slidesPerView: 2
		},
		1200: {
			slidesPerView: 3
		}
	}
});
